import { render, staticRenderFns } from "./CasePresenceDisplayHeader.vue?vue&type=template&id=c141a942"
import script from "./CasePresenceDisplayHeader.vue?vue&type=script&lang=js"
export * from "./CasePresenceDisplayHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports